export const loadJs = url => {
  return new Promise(resolve => {
    const script = document.createElement('script')
    script.src = url
    script.type = 'text/javascript'
    document.body.appendChild(script)
    script.onload = () => {
      resolve()
    }
  })
}

export const loadCss = url => {
  return new Promise(resolve => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = url
    document.head.appendChild(link)
    link.onload = () => {
      resolve()
    }
  })
}

export const generateUUID = () => {
  let d = new Date().getTime()
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      const r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c === 'x' ? r : (r & 0x7) | 0x8).toString(16)
    }
  )
  return uuid
}

export const resolveJson = (json, key, sign, jsonKeys) => {
  if (json instanceof Object) {
    if (key === '' || key === undefined) {
      key = 'main'
    }
    for (const p in json) {
      const k = key + sign + p
      if (!(json[p] instanceof Object)) {
        jsonKeys.push(p) // 如果不是Object则打印键值
      } else if (json[p] instanceof Array) {
        resolveJson(json[p][0], k, sign, jsonKeys) // 如果是数组则递归一个
      } else {
        resolveJson(json[p], k, sign, jsonKeys) // 如果是Object则递归
      }
    }
  } else {
    parent.layer.msg('请检查json格式', { icon: 5 })
  }
  return jsonKeys
}
export function debounce(fn, delay) {
  let timer = null
  return function () {
    const arg = arguments

    clearTimeout(timer)

    timer = setTimeout(() => {
      fn.apply(this, arg)
    }, delay)
  }
}
/** ************************************时间格式化处理************************************/
export function dateFormat(fmt, date) {
  // author: meizz
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds(), // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export const generateKeyToTD = rows => {
  for (let i = 0; i < rows.length; i++) {
    for (let j = 0; j < rows[i].columns.length; j++) {
      rows[i].columns[j].key = Math.random().toString(36).slice(-8)
    }
  }

  return rows
}

export const generateKeyToCol = columns => {
  for (let i = 0; i < columns.length; i++) {
    columns[i].key = Math.random().toString(36).slice(-8)
  }

  return columns
}
export const fixDraggbleList = (list, newIndex) => {
  // 处理拖拽过程中，列表值和返回的newIndex不一致问题

  const listIndex = list.findIndex(item => !item.key)

  if (listIndex >= 0) {
    list.splice(newIndex, 0, list.splice(listIndex, 1)[0])
  }
}

export const getCurDate = () => {
  const myDate = new Date()
  const year = myDate.getFullYear()
  const month = myDate.getMonth() + 1
  const date = myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate()
  return '' + year + month + date
}
